import Tabs from "./Tabs";

function Account() {
  return (
    <div className="homepage">
      <div className="title-section">
        <h1 className="title-name"> TAKL </h1>
      </div>
      <Tabs />
    </div>
  );
}

export default Account;
